module.exports = __webpack_public_path__ + "static/media/main_104.868df59c.ico";